import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";
const Privacy = () => {
  const [privacyContent, setPrivacyContent] = useState("");

  // In your Privacy.js component
useEffect(() => {
  // Clean up the localStorage flag when leaving the Privacy page
  return () => {
    localStorage.removeItem('viewingPrivacyFromCookieBanner');
  };
}, []);
  useEffect(() => {
    fetch("/privacy.txt")
      .then((res) => res.text())
      .then((text) => setPrivacyContent(text))
      .catch((err) => console.error("Failed to load Privacy Policy", err));
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy - limkc.com</title>
        <meta name="description" content="Read our Privacy Policy to understand how limkc.com handles data and protects user information." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="w-full h-full overflow-auto">
      <div className="px-4 py-6 transition-all duration-300"
   style={{
    paddingTop: 'calc(var(--navbar-height) + 1.5rem)', // Adds navbar height + existing py-6 (1.5rem)
  }}>
          <h2 className="text-xl font-bold mb-4 text-center text-gray-800">Privacy Policy</h2>
          <p className="text-sm text-gray-500 text-center mb-4">Last Updated: 2025-02-08</p>
          
          {/* Add this manual anchor */}
          <div id="cookies"></div>
          
          <div className="prose text-gray-600">
            <ReactMarkdown>{privacyContent}</ReactMarkdown>
          </div>
          <div className="text-center mt-6">
            <a href="/terms" className="text-blue-500 hover:underline">View Terms & Conditions</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;